var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    currentScope: '',
    crumbs: [],
    folders: [],
    foldersMeta: {},
    files: [],
    filesMeta: {},
    loading: false,
    errorLoadingFolders: false,
    errorLoadingFiles: false,
    errorSavingFile: false,
    errorDeletingFile: false,
    errorCreatingFolder: false,
    errorDeletingFolder: false,
    searchValue: '',
    selectedFolderId: '',
    selectedFile: null,
    fileType: '',
    filesWithLoadingError: [],
};
export var mediaSlice = createSlice({
    name: 'media',
    initialState: initialState,
    reducers: {
        loadFoldersRequest: function (state) {
            state.loading = true;
            state.errorLoadingFolders = false;
        },
        loadFoldersSuccess: function (state, _a) {
            var _b;
            var _c = _a.payload, payload = _c === void 0 ? {} : _c;
            state.folders = payload.folders || [];
            state.foldersMeta = payload.meta;
            state.selectedFolderId = ((_b = payload.folders[0]) === null || _b === void 0 ? void 0 : _b.id) || '';
            state.loading = false;
            state.errorLoadingFolders = false;
        },
        loadFoldersFailure: function (state, _a) {
            var payload = _a.payload;
            state.loading = false;
            state.errorLoadingFolders = payload.err;
        },
        loadFilesRequest: function (state) {
            state.loading = false;
            state.errorLoadingFolders = false;
        },
        loadFilesSuccess: function (state, _a) {
            var payload = _a.payload;
            state.files = payload.files || [];
            state.filesMeta = payload.meta;
            state.loading = false;
            state.errorLoadingFiles = false;
        },
        loadFilesFailure: function (state) {
            state.loading = false;
            state.errorLoadingFiles = true;
        },
        saveFileRequest: function (state) {
            state.errorSavingFile = false;
        },
        saveFileSuccess: function (state) {
            state.errorSavingFile = false;
        },
        saveFileFailure: function (state, _a) {
            var payload = _a.payload;
            state.errorSavingFile = true;
            state.filesWithLoadingError = __spreadArray(__spreadArray([], state.filesWithLoadingError, true), [payload], false);
        },
        deleteFileRequest: function (state) {
            state.errorDeletingFile = false;
        },
        deleteFileSuccess: function (state) {
            state.errorDeletingFile = false;
        },
        deleteFileFailure: function (state) {
            state.errorDeletingFile = true;
        },
        setSelectedFile: function (state, _a) {
            var payload = _a.payload;
            state.selectedFile = payload.file;
        },
        setSearchValue: function (state, _a) {
            var payload = _a.payload;
            state.searchValue = payload;
        },
        setFileType: function (state, _a) {
            var payload = _a.payload;
            state.fileType = payload;
        },
        uploadFileRequest: function (state, _a) {
            var payload = _a.payload;
            state.files = __spreadArray(__spreadArray([], (payload || []), true), state.files, true);
        },
        uploadFileSuccess: function (state, _a) {
            var payload = _a.payload;
            state.files = state.files.map(function (el) {
                return el.id === payload.id ? payload.file : el;
            });
        },
        updateErrorSavingFileState: function (state, _a) {
            var payload = _a.payload;
            state.errorSavingFile = payload.errorSavingFile || false;
        },
    },
});
export var saveFileRequest = (_a = mediaSlice.actions, _a.saveFileRequest), saveFileSuccess = _a.saveFileSuccess, saveFileFailure = _a.saveFileFailure, loadFoldersRequest = _a.loadFoldersRequest, loadFoldersSuccess = _a.loadFoldersSuccess, loadFoldersFailure = _a.loadFoldersFailure, deleteFileRequest = _a.deleteFileRequest, deleteFileSuccess = _a.deleteFileSuccess, deleteFileFailure = _a.deleteFileFailure, loadFilesRequest = _a.loadFilesRequest, loadFilesSuccess = _a.loadFilesSuccess, loadFilesFailure = _a.loadFilesFailure, setSelectedFile = _a.setSelectedFile, setSearchValue = _a.setSearchValue, setFileType = _a.setFileType, uploadFileRequest = _a.uploadFileRequest, uploadFileSuccess = _a.uploadFileSuccess, updateErrorSavingFileState = _a.updateErrorSavingFileState;
export default mediaSlice.reducer;
